import script from "./ExperimentShell.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperimentShell.vue?vue&type=script&setup=true&lang=js"

import "./ExperimentShell.vue?vue&type=style&index=0&id=00f53402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f53402"]])

export default __exports__